module.exports = __webpack_public_path__ + "static/media/dm1-pin.8d0988fa.svg";